import { takeLatest, call, put, select } from 'redux-saga/effects'
import log from 'loglevel';

import { Creators as actionMeasurementChart } from '../ducks/measurementChart'
import { requestDefaultJson } from './helpers'
import getEnvParam from '../../utils/getEnvParam';
import convertBase64 from '../../helpers/convertBase64'

function getChartFromAPI(order, token) {
  return requestDefaultJson({
    URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + '/report/tabelamedida/' + order,
    method: "GET",
    headers: {
      "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_REPORT"),
      "Authorization": token,
    }
  })
};

function setChartFromAPI(idPedido, file, fileName, token) {
  return requestDefaultJson({
    URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + '/report/tabelamedida/',
    method: "POST",
    headers: {
      "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_REPORT"),
      "Authorization": token,
    },
    data: {
      idPedido: idPedido,
      tabelaMedida: file,
      nomeArquivo: fileName,
    }
  })
};

function* getChart({payload}) {
  try{
    const { token } = yield select(state => state.authentication );

    yield put(actionMeasurementChart.getChartLoading());

    const data = yield call(getChartFromAPI, payload, token);

    yield put(actionMeasurementChart.getChartSuccess(data));
    
  } catch (error) {
    yield put(actionMeasurementChart.getChartError(error));

    log.info(error);
  }
}

function* setChart({payload}) {
  try{
    const { token } = yield select(state => state.authentication );

    yield put(actionMeasurementChart.sendChartLoading());

    const base64 = yield convertBase64(payload.file);

    const data = yield call(setChartFromAPI, payload.idPedido, base64, payload.file.name, token);

    yield put(actionMeasurementChart.sendChartSuccess(data));
    
  } catch (error) {
    yield put(actionMeasurementChart.sendChartError());

    log.info(error);
  }
}

// Generator function
export function* getMeasurementChart() {
  yield takeLatest("GET_CHART", getChart);
  yield takeLatest("SET_CHART", setChart);
}